import { Component, OnDestroy, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { LayoutService } from "./_layout/service/app.layout.service";
import { FBUserSession } from "./_core/interfaces/fb-user-session";
import { UserRoleEnum } from "./_core/enums/user-role.enum";
import { UserService } from "./_core/lib/user.service";
import { ProfileDTO } from './_core/classes/ProfileDTO';
import { UserController } from './_core/controllers/user.controller';
import { CtAuthenticationService } from '@ctsolution/ct-authentication';
import { TermsModalService } from './components/terms-dialog/TermsModalService.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {
termsModalVisible = false;

    tempUser: FBUserSession = {
        username: 'Francesco',
        role: UserRoleEnum.CUSTOMER
    }

    constructor(private termsModalService: TermsModalService,private primengConfig: PrimeNGConfig, private layoutService: LayoutService, private userService: UserService, private controller: UserController, private authService: CtAuthenticationService) {
        this.termsModalService.openModal$.subscribe(() => {
    this.openTermsModal();
  });
    }

    ngOnInit() {

        this.primengConfig.ripple = false;
        this.setup();

    }

    async setup() {

        this.layoutService.config.update((config) => ({
            ...config,
            theme: "lara-light-blue",
        }));


        //this.userService.setUserStorage();


    }
    openTermsModal(event?: Event): void {
  event?.preventDefault();
  this.termsModalVisible = true;
}

onTermsAccepted(): void {
  this.termsModalVisible = false;
}

    ngOnDestroy(): void {
        this.userService.deleteUser();
    }

}
